export const STATE_DISABLED = 'disabled'
export const STATE_ENABLED = 'enabled'
